import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import { CheckCircle2, Loader2, XCircle, ArrowUpRight } from "lucide-react";
import { formatApiErrorDetail, useAuth } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const { refresh } = useAuth();
  const [state, setState] = useState({ status: token ? "working" : "error", message: token ? "" : "This link is missing its code.", claimed: 0 });

  useEffect(() => {
    if (!token) return;
    axios.post(`${API}/auth/verify-email`, { token })
      .then(({ data }) => { setState({ status: "ok", message: "", claimed: data.claimed_purchases || 0 }); refresh?.(); })
      .catch((err) => setState({ status: "error", message: formatApiErrorDetail(err.response?.data?.detail) || err.message, claimed: 0 }));
  }, [token, refresh]);

  return (
    <main className="min-h-screen flex items-center justify-center px-6 py-24" data-testid="verify-email-page">
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="tacc-card max-w-md w-full p-10 text-center">
        {state.status === "working" && (
          <>
            <Loader2 size={28} className="animate-spin text-[#B45309] mx-auto mb-6" />
            <h1 className="font-display text-3xl tracking-tight">Confirming your email…</h1>
          </>
        )}
        {state.status === "ok" && (
          <>
            <CheckCircle2 size={32} className="text-emerald-400 mx-auto mb-6" />
            <h1 className="font-display text-4xl tracking-tight mb-3" data-testid="verify-email-success">Email confirmed.</h1>
            <p className="text-[#78716C] text-base mb-8">
              {state.claimed > 0 ? `We linked ${state.claimed} purchase${state.claimed > 1 ? "s" : ""} to your account.` : "You're all set."}
            </p>
            <Link to="/dashboard" data-testid="verify-email-dashboard" className="btn-ember text-sm">
              Go to your dashboard <ArrowUpRight size={14} />
            </Link>
          </>
        )}
        {state.status === "error" && (
          <>
            <XCircle size={32} className="text-red-400 mx-auto mb-6" />
            <h1 className="font-display text-3xl tracking-tight mb-3" data-testid="verify-email-error">That link didn't work.</h1>
            <p className="text-[#78716C] text-base mb-8">{state.message}</p>
            <Link to="/dashboard" className="btn-outline text-sm">Back to dashboard</Link>
          </>
        )}
      </motion.div>
    </main>
  );
}
